import { PERSON_COLORS, personColor } from '../sharing';

/** Scelte di aspetto del calendario (colori per persona). Logica pura, testata in __tests__/profile.test.ts. */
export function normalizeHex(input: string): string | null {
  const t = input.trim().replace(/^#?/, '#');
  if (/^#[0-9a-fA-F]{6}$/.test(t)) return t.toUpperCase();
  if (/^#[0-9a-fA-F]{3}$/.test(t)) return ('#' + t.slice(1).split('').map(c => c + c).join('')).toUpperCase();
  return null;
}

/** Imposta il colore di una persona; un valore non valido lascia tutto com'e'. */
export function setPersonColor(current: Record<string, string> | undefined, personId: string, hex: string): Record<string, string> {
  const n = normalizeHex(hex);
  if (!n) return { ...(current || {}) };
  return { ...(current || {}), [personId]: n };
}

/** Torna al colore automatico. */
export function resetPersonColor(current: Record<string, string> | undefined, personId: string): Record<string, string> {
  const { [personId]: _gone, ...rest } = current || {};
  return rest;
}

export function colorOfPerson(personId: string, orderedIds: readonly string[], custom?: Record<string, string> | null): string {
  return personColor(personId, orderedIds, custom);
}

export { PERSON_COLORS };
